import dhtmlXTreeObject from './dhtmlXTreeObject';
import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlx from '../../global/dhtmlx';
import cObject from './cObject';
import dhx_dragSomethingInTree from './dhx_dragSomethingInTree';
import dhtmlDragAndDropObject from '../dhtmlDragAndDropObject';

dhtmlXTreeObject.prototype._setCheck = function (a, e) {
    if (!a) {
        return;
    }
    if ((a.parentObject._r_logic || this._frbtr) && e) {
        if (this._frbtrs) {
            if (this._frbtrL) {
                this.setCheck(this._frbtrL.id, 0);
            }
            this._frbtrL = a;
        }
        else {
            for (var c = 0; c < a.parentObject.childsCount; c++) {
                this._setCheck(a.parentObject.childNodes[c], 0);
            }
        }
    }
    var g = a.htmlNode.childNodes[0].childNodes[0].childNodes[1].childNodes[0];
    if (e == "unsure") {
        a.checkstate = 2;
    }
    else {
        if (e) {
            a.checkstate = 1;
        }
        else {
            a.checkstate = 0;
        }
    }
    if (a.dscheck) {
        a.checkstate = a.dscheck;
    }
    this._setSrc(g, this.imPath +
        (a.parentObject._r_logic || this._frbtr
            ? this.radioArray
            : this.checkArray)[a.checkstate]);
};
dhtmlXTreeObject.prototype.setSubChecked = function (e, c) {
    var a = this._globalIdStorageFind(e);
    this._setSubChecked(c, a);
    this._correctCheckStates(a.parentObject);
};
dhtmlXTreeObject.prototype._setSubChecked = function (e, a) {
    e = dhx4.s2b(e);
    if (!a) {
        return;
    }
    if ((a.parentObject._r_logic || this._frbtr) && e) {
        for (var c = 0; c < a.parentObject.childsCount; c++) {
            this._setSubChecked(0, a.parentObject.childNodes[c]);
        }
    }
    if (a.unParsed) {
        this._setSubCheckedXML(e, a.unParsed);
    }
    if (a._r_logic || this._frbtr) {
        this._setSubChecked(e, a.childNodes[0]);
    }
    else {
        for (var c_1 = 0; c_1 < a.childsCount; c_1++) {
            this._setSubChecked(e, a.childNodes[c_1]);
        }
    }
    var g = a.htmlNode.childNodes[0].childNodes[0].childNodes[1].childNodes[0];
    if (e) {
        a.checkstate = 1;
    }
    else {
        a.checkstate = 0;
    }
    if (a.dscheck) {
        a.checkstate = a.dscheck;
    }
    this._setSrc(g, this.imPath +
        (a.parentObject._r_logic || this._frbtr
            ? this.radioArray
            : this.checkArray)[a.checkstate]);
};
dhtmlXTreeObject.prototype.isItemChecked = function (c) {
    var a = this._globalIdStorageFind(c);
    if (!a) {
        return;
    }
    return a.checkstate;
};
dhtmlXTreeObject.prototype.deleteChildItems = function (g) {
    var a = this._globalIdStorageFind(g);
    if (!a) {
        return;
    }
    var c = a.childsCount;
    for (var e = 0; e < c; e++) {
        this._deleteNode(a.childNodes[0].id, a.childNodes[0]);
    }
};
dhtmlXTreeObject.prototype.deleteItem = function (e, a) {
    if (!this._onrdlh || this._onrdlh(e)) {
        var c = this._deleteItem(e, a);
        if (c) {
            this._fixChildCountLabel(c);
        }
    }
    this.allTree.childNodes[0].border = "1";
    this.allTree.childNodes[0].border = "0";
};
dhtmlXTreeObject.prototype._deleteItem = function (l, c, h) {
    c = dhx4.s2b(c);
    var a = this._globalIdStorageFind(l);
    if (!a) {
        return;
    }
    var e = this.getParentId(l);
    var g = a.parentObject;
    this._deleteNode(l, a, h);
    if (this._editCell && this._editCell.id == l) {
        this._editCell = null;
    }
    this._correctPlus(g);
    this._correctLine(g);
    if (c && e != this.rootId) {
        this.selectItem(e, 1);
    }
    return g;
};
dhtmlXTreeObject.prototype._globalIdStorageRecSub = function (a) {
    for (var c = 0; c < a.childsCount; c++) {
        this._globalIdStorageRecSub(a.childNodes[c]);
        this._globalIdStorageSub(a.childNodes[c].id);
    }
    this._globalIdStorageSub(a.id);
    var e = a;
    e.span = null;
    e.tr.nodem = null;
    e.tr = null;
    e.htmlNode = null;
};
dhtmlXTreeObject.prototype.insertNewNext = function (n, s, r, e, l, h, g, c, a) {
    var m = this._globalIdStorageFind(n);
    if (!m || !m.parentObject) {
        return 0;
    }
    var o = this._attachChildNode(0, s, r, e, l, h, g, c, a, m);
    if (!this.XMLloadingWarning && this.childCalc) {
        this._fixChildCountLabel(m.parentObject);
    }
    return o;
};
dhtmlXTreeObject.prototype.getItemIdByIndex = function (e, a) {
    var c = this._globalIdStorageFind(e);
    if (!c || a >= c.childsCount) {
        return null;
    }
    return c.childNodes[a].id;
};
dhtmlXTreeObject.prototype.getChildItemIdByIndex = function (e, a) {
    var c = this._globalIdStorageFind(e);
    if (!c || a >= c.childsCount) {
        return null;
    }
    return c.childNodes[a].id;
};
dhtmlXTreeObject.prototype.setDragHandler = function (a) {
    this.attachEvent("onDrag", a);
};
dhtmlXTreeObject.prototype._clearMove = function () {
    if (this._lastMark) {
        this._lastMark.className = this._lastMark.className.replace(/dragAndDropRow/g, "");
        this._lastMark = null;
    }
    this.selectionBar.style.display = "none";
    this.allTree.className = this.allTree.className.replace(" selectionBox", "");
};
dhtmlXTreeObject.prototype.enableDragAndDrop = function (c, a) {
    if (c == "temporary_disabled") {
        this.dADTempOff = false;
        c = true;
    }
    else {
        this.dADTempOff = true;
    }
    this.dragAndDropOff = dhx4.s2b(c);
    if (this.dragAndDropOff) {
        this.dragger.addDragLanding(this.allTree, this);
    }
    if (arguments.length > 1) {
        this._ddronr = !dhx4.s2b(a);
    }
};
dhtmlXTreeObject.prototype._setMove = function (h, e, m) {
    if (h.parentObject.span) {
        var g = dhx4.absTop(h);
        var c = dhx4.absTop(this.allTree) - this.allTree.scrollTop;
        this.dadmodec = this.dadmode;
        this.dadmodefix = 0;
        if (this.dadmode == 2) {
            var l = m -
                g +
                (document.body.scrollTop || document.documentElement.scrollTop) -
                2 -
                h.offsetHeight / 2;
            if (Math.abs(l) - h.offsetHeight / 6 > 0) {
                this.dadmodec = 1;
                if (l < 0) {
                    this.dadmodefix = 0 - h.offsetHeight;
                }
            }
            else {
                this.dadmodec = 0;
            }
        }
        if (this.dadmodec == 0) {
            var a = h.parentObject.span;
            a.className += " dragAndDropRow";
            this._lastMark = a;
        }
        else {
            this._clearMove();
            this.selectionBar.style.top =
                g -
                    c +
                    ((parseInt(h.parentObject.span.parentNode.parentNode.offsetHeight) ||
                        18) -
                        1) +
                    this.dadmodefix +
                    "px";
            this.selectionBar.style.left = "5px";
            if (this.allTree.offsetWidth > 20) {
                this.selectionBar.style.width =
                    this.allTree.offsetWidth - (window._isFF ? 30 : 25) + "px";
            }
            this.selectionBar.style.display = "";
        }
        this._autoScroll(null, g, c);
    }
};
dhtmlXTreeObject.prototype._autoScroll = function (e, c, a) {
    if (this.autoScroll) {
        if (e) {
            c = dhx4.absTop(e);
            a = dhx4.absTop(this.allTree) - this.allTree.scrollTop;
        }
        if (c - a - parseInt(this.allTree.scrollTop) >
            parseInt(this.allTree.offsetHeight) - 50) {
            this.allTree.scrollTop = parseInt(this.allTree.scrollTop) + 20;
        }
        if (c - a < parseInt(this.allTree.scrollTop) + 30) {
            this.allTree.scrollTop = parseInt(this.allTree.scrollTop) - 20;
        }
    }
};
dhtmlXTreeObject.prototype._createDragNode = function (l, h) {
    if (!this.dADTempOff) {
        return null;
    }
    var g = l.parentObject;
    if (!this.callEvent("onBeforeDrag", [g.id, h])) {
        return null;
    }
    if (!g.i_sel) {
        this._selectItem(g, h);
    }
    this._checkMSelectionLogic();
    var c = document.createElement("div");
    var m = new Array();
    if (this._itim_dg) {
        for (var a = 0; a < this._selected.length; a++) {
            m[a] =
                "<table cellspacing='0' cellpadding='0'><tr><td><img width='18px' height='18px' src='" +
                    this._getSrc(this._selected[a].span.parentNode.previousSibling.childNodes[0]) +
                    "'></td><td>" +
                    this._selected[a].span.innerHTML +
                    "</td></tr></table>";
        }
    }
    else {
        m = this.getSelectedItemText().split(this.dlmtr);
    }
    c.innerHTML = m.join("");
    c.style.position = "absolute";
    c.className = "dragSpanDiv";
    this._dragged = new Array().concat(this._selected);
    return c;
};
dhtmlXTreeObject.prototype._focusNode = function (a) {
    var c = dhx4.absTop(a.htmlNode) - dhx4.absTop(this.allTree);
    if (c > this.allTree.offsetHeight - 30 || c < 0) {
        this.allTree.scrollTop = c + this.allTree.scrollTop;
    }
};
dhtmlXTreeObject.prototype._preventNsDrag = function (a) {
    if (a && a.preventDefault) {
        a.preventDefault();
        return false;
    }
    return false;
};
dhtmlXTreeObject.prototype._drag = function (m, n, a) {
    if (this._autoOpenTimer) {
        clearTimeout(this._autoOpenTimer);
    }
    if (!a.parentObject) {
        a = this.htmlNode.htmlNode.childNodes[0].childNodes[0].childNodes[1]
            .childNodes[0];
        this.dadmodec = 0;
    }
    this._clearMove();
    var l = m.parentObject.treeNod;
    if (l && l._clearMove) {
        l._clearMove("");
    }
    var g = null;
    if (!this.dragMove || this.dragMove()) {
        if (!l || !l._clearMove || !l._dragged) {
            g = new Array(m.parentObject);
        }
        else {
            g = l._dragged;
        }
        var c = a.parentObject;
        for (var h = 0; h < g.length; h++) {
            var e = this._moveNode(g[h], c);
            if (this.dadmodec && e !== false) {
                c = this._globalIdStorageFind(e, true, true);
            }
            if (e && !this._sADnD) {
                this.selectItem(e, 0, 1);
            }
        }
    }
    if (l) {
        l._dragged = new Array();
    }
};
dhtmlXTreeObject.prototype._dragIn = function (g, c, l, h) {
    if (!this.dADTempOff) {
        return 0;
    }
    var m = c.parentObject;
    var a = g.parentObject;
    if (!a && this._ddronr) {
        return;
    }
    if (!this.callEvent("onDragIn", [m.id, a ? a.id : null, m.treeNod, this])) {
        if (a) {
            this._autoScroll(g);
        }
        return 0;
    }
    if (!a) {
        this.allTree.className += " selectionBox";
    }
    else {
        if (m.childNodes == null) {
            this._setMove(g, l, h);
            return g;
        }
        var o = m.treeNod;
        for (var e = 0; e < o._dragged.length; e++) {
            if (this._checkPNodes(a, o._dragged[e])) {
                this._autoScroll(g);
                return 0;
            }
        }
        this.selectionBar.parentNode.removeChild(this.selectionBar);
        a.span.parentNode.appendChild(this.selectionBar);
        this._setMove(g, l, h);
        if (this._getOpenState(a) <= 0) {
            var n = this;
            this._autoOpenId = a.id;
            this._autoOpenTimer = window.setTimeout(function () {
                n._autoOpenItem(null, n);
                n = null;
            }, 1000);
        }
    }
    return g;
};
dhtmlXTreeObject.prototype._autoOpenItem = function (c, a) {
    a.openItem(a._autoOpenId);
};
dhtmlXTreeObject.prototype._dragOut = function () {
    this._clearMove();
    if (this._autoOpenTimer) {
        clearTimeout(this._autoOpenTimer);
    }
};
dhtmlXTreeObject.prototype._getNextNode = function (a, c) {
    if (!c && a.childsCount) {
        return a.childNodes[0];
    }
    if (a == this.htmlNode) {
        return -1;
    }
    if (a.tr && a.tr.nextSibling && a.tr.nextSibling.nodem) {
        return a.tr.nextSibling.nodem;
    }
    return this._getNextNode(a.parentObject, true);
};
dhtmlXTreeObject.prototype._lastChild = function (a) {
    if (a.childsCount) {
        return this._lastChild(a.childNodes[a.childsCount - 1]);
    }
    else {
        return a;
    }
};
dhtmlXTreeObject.prototype._getPrevNode = function (a) {
    if (a.tr && a.tr.previousSibling && a.tr.previousSibling.nodem) {
        return this._lastChild(a.tr.previousSibling.nodem);
    }
    if (a.parentObject) {
        return a.parentObject;
    }
    else {
        return -1;
    }
};
dhtmlXTreeObject.prototype.findItem = function (a, e, c) {
    var g = this._findNodeByLabel(a, e, c ? this.htmlNode : null);
    if (g) {
        this.selectItem(g.id, true);
        this._focusNode(g);
        return g.id;
    }
    else {
        return null;
    }
};
dhtmlXTreeObject.prototype.findItemIdByLabel = function (a, e, c) {
    var g = this._findNodeByLabel(a, e, c ? this.htmlNode : null);
    if (g) {
        return g.id;
    }
    else {
        return null;
    }
};
dhtmlXTreeObject.prototype.findStrInXML = function (c, e, h) {
    if (!c.childNodes && c.item) {
        return this.findStrInJSON(c, e, h);
    }
    if (!c.childNodes) {
        return false;
    }
    for (var a = 0; a < c.childNodes.length; a++) {
        if (c.childNodes[a].nodeType == 1) {
            var g = c.childNodes[a].getAttribute(e);
            if (!g && c.childNodes[a].tagName == "itemtext") {
                g = c.childNodes[a].firstChild.data;
            }
            if (g && g.toLowerCase().search(h) != -1) {
                return true;
            }
            if (this.findStrInXML(c.childNodes[a], e, h)) {
                return true;
            }
        }
    }
    return false;
};
dhtmlXTreeObject.prototype.findStrInJSON = function (c, e, h) {
    for (var a = 0; a < c.item.length; a++) {
        var g = c.item[a].text;
        if (g && g.toLowerCase().search(h) != -1) {
            return true;
        }
        if (c.item[a].item && this.findStrInJSON(c.item[a], e, h)) {
            return true;
        }
    }
    return false;
};
dhtmlXTreeObject.prototype._findNodeByLabel = function (aStr, h, g) {
    var a = aStr.replace(new RegExp("^( )+"), "").replace(new RegExp("( )+$"), "");
    a = new RegExp(a.replace(/([\^\.\?\*\+\\\[\]\(\)]{1})/gi, "\\$1").replace(/ /gi, ".*"), "gi");
    if (!g) {
        g = this._selected[0];
        if (!g) {
            g = this.htmlNode;
        }
    }
    var c = g;
    if (!h) {
        if (g.unParsed && this.findStrInXML(g.unParsed.d, "text", a)) {
            this.reParse(g);
        }
        g = this._getNextNode(c);
        if (g == -1) {
            g = this.htmlNode.childNodes[0];
        }
    }
    else {
        var e = this._getPrevNode(c);
        if (e == -1) {
            e = this._lastChild(this.htmlNode);
        }
        if (e.unParsed && this.findStrInXML(e.unParsed.d, "text", a)) {
            this.reParse(e);
            g = this._getPrevNode(c);
        }
        else {
            g = e;
        }
        if (g == -1) {
            g = this._lastChild(this.htmlNode);
        }
    }
    while (g && g != c) {
        if (g.label && g.label.search(a) != -1) {
            return g;
        }
        if (!h) {
            if (g == -1) {
                if (c == this.htmlNode) {
                    break;
                }
                g = this.htmlNode.childNodes[0];
            }
            if (g.unParsed && this.findStrInXML(g.unParsed.d, "text", a)) {
                this.reParse(g);
            }
            g = this._getNextNode(g);
            if (g == -1) {
                g = this.htmlNode;
            }
        }
        else {
            var eNode = this._getPrevNode(g);
            if (eNode == -1) {
                eNode = this._lastChild(this.htmlNode);
            }
            if (eNode.unParsed && this.findStrInXML(eNode.unParsed.d, "text", a)) {
                this.reParse(eNode);
                g = this._getPrevNode(g);
            }
            else {
                g = eNode;
            }
            if (g == -1) {
                g = this._lastChild(this.htmlNode);
            }
        }
    }
    return null;
};
dhtmlXTreeObject.prototype.moveItem = function (n, c, o, a) {
    var h = this._globalIdStorageFind(n);
    if (!h) {
        return 0;
    }
    var l = null;
    switch (c) {
        case "right":
            alert("Not supported yet");
            break;
        case "item_child":
            var eObj = (a || this)._globalIdStorageFind(o);
            if (!eObj) {
                return 0;
            }
            l = (a || this)._moveNodeTo(h, eObj, 0);
            break;
        case "item_sibling":
            var siblingEl = (a || this)._globalIdStorageFind(o);
            if (!siblingEl) {
                return 0;
            }
            l = (a || this)._moveNodeTo(h, siblingEl.parentObject, siblingEl);
            break;
        case "item_sibling_next":
            var nextEl = (a || this)._globalIdStorageFind(o);
            if (!nextEl) {
                return 0;
            }
            if (nextEl.tr && nextEl.tr.nextSibling && nextEl.tr.nextSibling.nodem) {
                l = (a || this)._moveNodeTo(h, nextEl.parentObject, nextEl.tr.nextSibling.nodem);
            }
            else {
                l = (a || this)._moveNodeTo(h, nextEl.parentObject);
            }
            break;
        case "left":
            if (h.parentObject.parentObject) {
                l = this._moveNodeTo(h, h.parentObject.parentObject, h.parentObject);
            }
            break;
        case "up":
            var upEl = this._getPrevNode(h);
            if (upEl == -1 || !upEl.parentObject) {
                return null;
            }
            l = this._moveNodeTo(h, upEl.parentObject, upEl);
            break;
        case "up_strict":
            var strictEl = this._getIndex(h);
            if (strictEl != 0) {
                l = this._moveNodeTo(h, h.parentObject, h.parentObject.childNodes[strictEl - 1]);
            }
            break;
        case "down_strict":
            var downEl = this._getIndex(h);
            var g = h.parentObject.childsCount - 2;
            if (downEl == g) {
                l = this._moveNodeTo(h, h.parentObject);
            }
            else {
                if (downEl < g) {
                    l = this._moveNodeTo(h, h.parentObject, h.parentObject.childNodes[downEl + 2]);
                }
            }
            break;
        case "down":
            var mDown = this._getNextNode(this._lastChild(h));
            if (mDown == -1 || !mDown.parentObject) {
                return;
            }
            if (mDown.parentObject == h.parentObject) {
                mDown = this._getNextNode(mDown);
            }
            if (mDown == -1) {
                l = this._moveNodeTo(h, h.parentObject);
            }
            else {
                if (mDown == -1 || !mDown.parentObject) {
                    return;
                }
                l = this._moveNodeTo(h, mDown.parentObject, mDown);
            }
            break;
    }
    if (window._isIE && window._isIE < 8) {
        this.allTree.childNodes[0].border = "1";
        this.allTree.childNodes[0].border = "0";
    }
    return l;
};
dhtmlXTreeObject.prototype.setDragBehavior = function (c, a) {
    this._sADnD = !dhx4.s2b(a);
    switch (c) {
        case "child":
            this.dadmode = 0;
            break;
        case "sibling":
            this.dadmode = 1;
            break;
        case "complex":
            this.dadmode = 2;
            break;
    }
};
dhtmlXTreeObject.prototype._loadDynXML = function (e, c) {
    c = c || this.XMLsource;
    var a = new Date().valueOf();
    this._ld_id = e;
    if (this.xmlalb == "function") {
        if (c) {
            c(this._escape(e));
        }
    }
    else {
        if (this.xmlalb == "name") {
            this.load(c + this._escape(e));
        }
        else {
            if (this.xmlalb == "xmlname") {
                this.load(c + this._escape(e) + ".xml?uid=" + a);
            }
            else {
                this.load(c + dhtmlx.url(c) + "uid=" + a + "&id=" + this._escape(e));
            }
        }
    }
};
dhtmlXTreeObject.prototype.enableMultiselection = function (c, a) {
    this._amsel = dhx4.s2b(c);
    this._amselS = dhx4.s2b(a);
};
dhtmlXTreeObject.prototype._checkMSelectionLogic = function () {
    var e = new Array();
    for (var c = 0; c < this._selected.length; c++) {
        for (var a = 0; a < this._selected.length; a++) {
            if (c != a && this._checkPNodes(this._selected[a], this._selected[c])) {
                e[e.length] = this._selected[a];
            }
        }
    }
    for (var c_2 = 0; c_2 < e.length; c_2++) {
        this._unselectItem(e[c_2]);
    }
};
dhtmlXTreeObject.prototype._checkPNodes = function (c, a) {
    if (this._dcheckf) {
        return false;
    }
    if (a == c) {
        return 1;
    }
    if (c.parentObject) {
        return this._checkPNodes(c.parentObject, a);
    }
    else {
        return 0;
    }
};
dhtmlXTreeObject.prototype.disableDropCheck = function (a) {
    this._dcheckf = dhx4.s2b(a);
};
dhtmlXTreeObject.prototype.enableDistributedParsing = function (e, c, a) {
    this._edsbps = dhx4.s2b(e);
    this._edsbpsA = new Array();
    this._edsbpsC = c || 10;
    this._edsbpsD = a || 250;
};
dhtmlXTreeObject.prototype.getDistributedParsingState = function () {
    return !(!this._edsbpsA || !this._edsbpsA.length);
};
dhtmlXTreeObject.prototype.getItemParsingState = function (e) {
    var c = this._globalIdStorageFind(e, true, true);
    if (!c) {
        return 0;
    }
    if (this._edsbpsA) {
        for (var a = 0; a < this._edsbpsA.length; a++) {
            if (this._edsbpsA[a][2] == e) {
                return -1;
            }
        }
    }
    return 1;
};
dhtmlXTreeObject.prototype._distributedStart = function (c, h, g, e, a) {
    if (!this._edsbpsA) {
        this._edsbpsA = new Array();
    }
    this._edsbpsA[this._edsbpsA.length] = [c, h, g, e, a];
};
dhtmlXTreeObject.prototype._distributedStep = function (g) {
    var c = this;
    if (!this._edsbpsA || !this._edsbpsA.length) {
        c.XMLloadingWarning = 0;
        return;
    }
    var h = this._edsbpsA[0];
    this.parsedArray = new Array();
    this._parse(h[0], h[2], h[3], h[1]);
    var a = this._globalIdStorageFind(h[2]);
    this._redrawFrom(this, a, h[4], this._getOpenState(a));
    var e = this.setCheckList.split(this.dlmtr);
    for (var l = 0; l < e.length; l++) {
        if (e[l]) {
            this.setCheck(e[l], 1);
        }
    }
    this._edsbpsA = new Array().concat(this._edsbpsA.slice(1));
    if (!this._edsbpsA.length) {
        window.setTimeout(function () {
            if (c.onXLE) {
                c.onXLE(c, g);
            }
            c.callEvent("onXLE", [c, g]);
        }, 1);
        c.xmlstate = 0;
    }
};
dhtmlXTreeObject.prototype.enableTextSigns = function (a) {
    this._txtimg = dhx4.s2b(a);
};
dhtmlXTreeObject.prototype.preventIECaching = function (a) {
    dhx4.ajax.cache = !a;
};
dhtmlXTreeObject.prototype.preventIECashing =
    dhtmlXTreeObject.prototype.preventIECaching;
dhtmlXTreeObject.prototype.disableCheckbox = function (e, c) {
    var a = null;
    if (typeof e != "object") {
        a = this._globalIdStorageFind(e, 0, 1);
    }
    else {
        a = e;
    }
    if (!a) {
        return;
    }
    a.dscheck = dhx4.s2b(c)
        ? ((a.checkstate || 0) % 3) + 3
        : a.checkstate > 2
            ? a.checkstate - 3
            : a.checkstate;
    this._setCheck(a);
    if (a.dscheck < 3) {
        a.dscheck = false;
    }
};
dhtmlXTreeObject.prototype.smartRefreshBranch = function (c, a) {
    this._branchUpdate = 1;
    this.smartRefreshItem(c, a);
};
dhtmlXTreeObject.prototype.smartRefreshItem = function (g, e) {
    var a = this._globalIdStorageFind(g);
    for (var c = 0; c < a.childsCount; c++) {
        a.childNodes[c]._dmark = true;
    }
    this.waitUpdateXML = true;
    if (e && e.exists) {
        this._parse(e, g);
    }
    else {
        this._loadDynXML(g, e);
    }
};
dhtmlXTreeObject.prototype.refreshItems = function (c, e) {
    var g = c.toString().split(this.dlmtr);
    this.waitUpdateXML = new Array();
    for (var a = 0; a < g.length; a++) {
        this.waitUpdateXML[g[a]] = true;
    }
    this.load((e || this.XMLsource) +
        dhtmlx.url(e || this.XMLsource) +
        "ids=" +
        this._escape(c));
};
dhtmlXTreeObject.prototype.updateItem = function (m, l, g, e, c, h, n) {
    var a = this._globalIdStorageFind(m);
    a.userData = new cObject();
    if (l) {
        a.label = l;
    }
    a.images = new Array(g || this.imageArray[0], e || this.imageArray[1], c || this.imageArray[2]);
    this.setItemText(m, l);
    if (h) {
        this._setCheck(a, true);
    }
    if (n == "1" && !this.hasChildren(m)) {
        a.XMLload = 0;
    }
    this._correctPlus(a);
    a._dmark = false;
    return a;
};
dhtmlXTreeObject.prototype.setDropHandler = function (a) {
    this.attachEvent("onDrop", a);
};
dhtmlXTreeObject.prototype.setOnLoadingStart = function (a) {
    this.attachEvent("onXLS", a);
};
dhtmlXTreeObject.prototype.setOnLoadingEnd = function (a) {
    this.attachEvent("onXLE", a);
};
dhtmlXTreeObject.prototype.setXMLAutoLoadingBehaviour = function (a) {
    this.xmlalb = a;
};
dhtmlXTreeObject.prototype.enableSmartCheckboxes = function (a) {
    this.smcheck = dhx4.s2b(a);
};
dhtmlXTreeObject.prototype.getXMLState = function () {
    return this.xmlstate == 1;
};
dhtmlXTreeObject.prototype.setItemTopOffset = function (l, g) {
    var e;
    if (typeof l != "object") {
        e = this._globalIdStorageFind(l);
    }
    else {
        e = l;
    }
    var h = e.span.parentNode.parentNode;
    e.span.style.paddingBottom = "1px";
    for (var c = 0; c < h.childNodes.length; c++) {
        if (c != 0) {
            if (window._isIE) {
                h.childNodes[c].style.height = "18px";
                h.childNodes[c].style.paddingTop = parseInt(g) + "px";
            }
            else {
                h.childNodes[c].style.height = 18 + parseInt(g) + "px";
            }
        }
        else {
            var a = h.childNodes[c].firstChild;
            if (h.childNodes[c].firstChild.tagName != "DIV") {
                a = document.createElement("DIV");
                h.childNodes[c].insertBefore(a, h.childNodes[c].firstChild);
            }
            if ((e.parentObject.id != this.rootId ||
                e.parentObject.childNodes[0] != e) &&
                this.treeLinesOn) {
                h.childNodes[c].style.backgroundImage =
                    "url(" + this.imPath + this.lineArray[5] + ")";
            }
            a.innerHTML = "&nbsp;";
            a.style.overflow = "hidden";
        }
        a.style.verticalAlign = h.childNodes[c].style.verticalAlign = "bottom";
        if (window._isIE) {
            this.allTree.childNodes[0].border = "1";
            this.allTree.childNodes[0].border = "0";
        }
    }
};
dhtmlXTreeObject.prototype.setIconSize = function (g, c, h) {
    var a = null;
    if (h) {
        if (h && h.span) {
            a = h;
        }
        else {
            a = this._globalIdStorageFind(h);
        }
        if (!a) {
            return 0;
        }
        var e = a.span.parentNode.previousSibling.childNodes[0];
        if (g) {
            e.style.width = g + "px";
            if (window._KHTMLrv) {
                e.parentNode.style.width = g + "px";
            }
        }
        if (c) {
            e.style.height = c + "px";
            if (window._KHTMLrv) {
                e.parentNode.style.height = c + "px";
            }
        }
    }
    else {
        this.def_img_x = g + "px";
        this.def_img_y = c + "px";
    }
};
dhtmlXTreeObject.prototype.getItemImage = function (h, g, c) {
    var e = this._globalIdStorageFind(h);
    if (!e) {
        return "";
    }
    var a = e.images[g || 0];
    if (c) {
        a = this.iconURL + a;
    }
    return a;
};
dhtmlXTreeObject.prototype.enableRadioButtons = function (g, e) {
    if (arguments.length == 1) {
        this._frbtr = dhx4.s2b(g);
        this.checkBoxOff = this.checkBoxOff || this._frbtr;
        return;
    }
    var c = this._globalIdStorageFind(g);
    if (!c) {
        return "";
    }
    e = dhx4.s2b(e);
    if (e && !c._r_logic) {
        c._r_logic = true;
        for (var a = 0; a < c.childsCount; a++) {
            this._setCheck(c.childNodes[a], c.childNodes[a].checkstate);
        }
    }
    if (!e && c._r_logic) {
        c._r_logic = false;
        for (var a_1 = 0; a_1 < c.childsCount; a_1++) {
            this._setCheck(c.childNodes[a_1], c.childNodes[a_1].checkstate);
        }
    }
};
dhtmlXTreeObject.prototype.enableSingleRadioMode = function (a) {
    this._frbtrs = dhx4.s2b(a);
};
dhtmlXTreeObject.prototype.openOnItemAdded = function (a) {
    this._hAdI = !dhx4.s2b(a);
};
dhtmlXTreeObject.prototype.openOnItemAdding = function (a) {
    this._hAdI = !dhx4.s2b(a);
};
dhtmlXTreeObject.prototype.enableMultiLineItems = function (a) {
    if (a === true) {
        this.mlitems = "100%";
    }
    else {
        this.mlitems = a;
    }
};
dhtmlXTreeObject.prototype.enableAutoTooltips = function (a) {
    this.ettip = dhx4.s2b(a);
};
dhtmlXTreeObject.prototype.clearSelection = function (a) {
    if (a) {
        this._unselectItem(this._globalIdStorageFind(a));
    }
    else {
        this._unselectItems();
    }
};
dhtmlXTreeObject.prototype.showItemSign = function (g, c) {
    var a = this._globalIdStorageFind(g);
    if (!a) {
        return 0;
    }
    a.span.parentNode.previousSibling.previousSibling.previousSibling;
    if (!dhx4.s2b(c)) {
        this._openItem(a);
        a.closeble = false;
        a.wsign = true;
    }
    else {
        a.closeble = true;
        a.wsign = false;
    }
    this._correctPlus(a);
};
dhtmlXTreeObject.prototype.showItemCheckbox = function (h, g) {
    if (!h) {
        for (var c in this._idpull) {
            this.showItemCheckbox(this._idpull[c], g);
        }
    }
    if (typeof h != "object") {
        h = this._globalIdStorageFind(h, 0, 0);
    }
    if (!h) {
        return 0;
    }
    h.nocheckbox = !dhx4.s2b(g);
    var e = h.span.parentNode.previousSibling.previousSibling.childNodes[0];
    e.parentNode.style.display = !h.nocheckbox ? "" : "none";
};
dhtmlXTreeObject.prototype.setListDelimeter = function (a) {
    this.dlmtr = a;
};
dhtmlXTreeObject.prototype.setEscapingMode = function (a) {
    this.utfesc = a;
};
dhtmlXTreeObject.prototype.enableHighlighting = function (a) {
    this.ehlt = true;
    this.ehlta = dhx4.s2b(a);
};
dhtmlXTreeObject.prototype._itemMouseOut = function () {
    var c = this.childNodes[3].parentObject;
    var a = c.treeNod;
    a.callEvent("onMouseOut", [c.id]);
    if (c.id == a._l_onMSI) {
        a._l_onMSI = null;
    }
    if (!a.ehlta) {
        return;
    }
    c.span.className = c.span.className.replace("_lor", "");
};
dhtmlXTreeObject.prototype._itemMouseIn = function () {
    var c = this.childNodes[3].parentObject;
    var a = c.treeNod;
    if (a._l_onMSI != c.id) {
        a.callEvent("onMouseIn", [c.id]);
    }
    a._l_onMSI = c.id;
    if (!a.ehlta) {
        return;
    }
    c.span.className = c.span.className.replace("_lor", "");
    c.span.className = c.span.className.replace(/((standart|selected)TreeRow)/, "$1_lor");
};
dhtmlXTreeObject.prototype.enableActiveImages = function (a) {
    this._aimgs = dhx4.s2b(a);
};
dhtmlXTreeObject.prototype.focusItem = function (c) {
    var a = this._globalIdStorageFind(c);
    if (!a) {
        return 0;
    }
    this._focusNode(a);
};
dhtmlXTreeObject.prototype.getAllSubItems = function (a) {
    return this._getAllSubItems(a);
};
dhtmlXTreeObject.prototype.getAllChildless = function () {
    return this._getAllScraggyItems(this.htmlNode);
};
dhtmlXTreeObject.prototype.getAllLeafs =
    dhtmlXTreeObject.prototype.getAllChildless;
dhtmlXTreeObject.prototype._getAllScraggyItems = function (e) {
    var g = "";
    var a = null;
    for (var c = 0; c < e.childsCount; c++) {
        if (e.childNodes[c].unParsed || e.childNodes[c].childsCount > 0) {
            if (e.childNodes[c].unParsed) {
                a = this._getAllScraggyItemsXML(e.childNodes[c].unParsed, 1);
            }
            else {
                a = this._getAllScraggyItems(e.childNodes[c]);
            }
            if (a) {
                if (g) {
                    g += this.dlmtr + a;
                }
                else {
                    g = a;
                }
            }
        }
        else {
            if (!g) {
                g = "" + e.childNodes[c].id;
            }
            else {
                g += this.dlmtr + e.childNodes[c].id;
            }
        }
    }
    return g;
};
dhtmlXTreeObject.prototype._getAllFatItems = function (e) {
    var g = "";
    var a = null;
    for (var c = 0; c < e.childsCount; c++) {
        if (e.childNodes[c].unParsed || e.childNodes[c].childsCount > 0) {
            if (!g) {
                g = "" + e.childNodes[c].id;
            }
            else {
                g += this.dlmtr + e.childNodes[c].id;
            }
            if (e.childNodes[c].unParsed) {
                a = this._getAllFatItemsXML(e.childNodes[c].unParsed, 1);
            }
            else {
                a = this._getAllFatItems(e.childNodes[c]);
            }
            if (a) {
                g += this.dlmtr + a;
            }
        }
    }
    return g;
};
dhtmlXTreeObject.prototype.getAllItemsWithKids = function () {
    return this._getAllFatItems(this.htmlNode);
};
dhtmlXTreeObject.prototype.getAllFatItems =
    dhtmlXTreeObject.prototype.getAllItemsWithKids;
dhtmlXTreeObject.prototype.getAllChecked = function () {
    return this._getAllChecked("", "", 1);
};
dhtmlXTreeObject.prototype.getAllUnchecked = function (a) {
    if (a) {
        a = this._globalIdStorageFind(a);
    }
    return this._getAllChecked(a, "", 0);
};
dhtmlXTreeObject.prototype.getAllPartiallyChecked = function () {
    return this._getAllChecked("", "", 2);
};
dhtmlXTreeObject.prototype.getAllCheckedBranches = function () {
    var a = [this._getAllChecked("", "", 1)];
    var c = this._getAllChecked("", "", 2);
    if (c) {
        a.push(c);
    }
    return a.join(this.dlmtr);
};
dhtmlXTreeObject.prototype._getAllChecked = function (g, e, h) {
    if (!g) {
        g = this.htmlNode;
    }
    if (g.checkstate == h) {
        if (!g.nocheckbox) {
            if (e) {
                e += this.dlmtr + g.id;
            }
            else {
                e = "" + g.id;
            }
        }
    }
    var a = g.childsCount;
    for (var c = 0; c < a; c++) {
        e = this._getAllChecked(g.childNodes[c], e, h);
    }
    if (g.unParsed) {
        e = this._getAllCheckedXML(g.unParsed, e, h);
    }
    if (e) {
        return e;
    }
    else {
        return "";
    }
};
dhtmlXTreeObject.prototype.setItemStyle = function (g, e, c) {
    var cObj = c || false;
    var a = this._globalIdStorageFind(g);
    if (!a) {
        return 0;
    }
    if (!a.span.style.cssText) {
        a.span.setAttribute("style", a.span.getAttribute("style") + "; " + e);
    }
    else {
        a.span.style.cssText = cObj ? e : a.span.style.cssText + ";" + e;
    }
};
dhtmlXTreeObject.prototype.enableImageDrag = function (a) {
    this._itim_dg = dhx4.s2b(a);
};
dhtmlXTreeObject.prototype.setOnDragIn = function (a) {
    this.attachEvent("onDragIn", a);
};
dhtmlXTreeObject.prototype.enableDragAndDropScrolling = function (a) {
    this.autoScroll = dhx4.s2b(a);
};
dhtmlXTreeObject.prototype.setSkin = function (a) {
    var c = this.parentObject.className.replace(/dhxtree_[^ ]*/gi, "");
    this.parentObject.className = c + " dhxtree_" + a;
    if (a == "dhx_terrace" || a == "dhx_web" || a == "material") {
        this.enableTreeLines(false);
    }
    if (a == "material") {
        this.setIconSize("25", "25");
    }
};
(function () {
    dhtmlx.extend_api("dhtmlXTreeObject", {
        _init: function (a) {
            return [
                a.parent,
                a.width || "100%",
                a.height || "100%",
                a.root_id || 0
            ];
        },
        auto_save_selection: "enableAutoSavingSelected",
        auto_tooltip: "enableAutoTooltips",
        checkbox: "enableCheckBoxes",
        checkbox_3_state: "enableThreeStateCheckboxes",
        checkbox_smart: "enableSmartCheckboxes",
        context_menu: "enableContextMenu",
        distributed_parsing: "enableDistributedParsing",
        drag: "enableDragAndDrop",
        drag_copy: "enableMercyDrag",
        drag_image: "enableImageDrag",
        drag_scroll: "enableDragAndDropScrolling",
        editor: "enableItemEditor",
        hover: "enableHighlighting",
        images: "enableTreeImages",
        image_fix: "enableIEImageFix",
        image_path: "setImagePath",
        lines: "enableTreeLines",
        loading_item: "enableLoadingItem",
        multiline: "enableMultiLineItems",
        multiselect: "enableMultiselection",
        navigation: "enableKeyboardNavigation",
        radio: "enableRadioButtons",
        radio_single: "enableSingleRadioMode",
        rtl: "enableRTL",
        search: "enableKeySearch",
        smart_parsing: "enableSmartXMLParsing",
        smart_rendering: "enableSmartRendering",
        text_icons: "enableTextSigns",
        xml: "loadXML",
        skin: "setSkin"
    }, {});
})();
dhtmlXTreeObject.prototype._dp_init = function (a) {
    a.attachEvent("insertCallback", function (g, l, c) {
        var e = dhx4.ajax.xpath(".//item", g);
        var h = e[0].getAttribute("text");
        this.obj.insertNewItem(c, l, h, 0, 0, 0, 0, "CHILD");
    });
    a.attachEvent("updateCallback", function (g, l, c) {
        var e = dhx4.ajax.xpath(".//item", g);
        var h = e[0].getAttribute("text");
        this.obj.setItemText(l, h);
        if (this.obj.getParentId(l) != c) {
            this.obj.moveItem(l, "item_child", c);
        }
        this.setUpdated(l, true, "updated");
    });
    a.attachEvent("deleteCallback", function (e, g) {
        this.obj.setUserData(g, this.action_param, "true_deleted");
        this.obj.deleteItem(g, false);
    });
    a._methods = ["setItemStyle", "", "changeItemId", "deleteItem"];
    this.attachEvent("onEdit", function (c, e) {
        if (c == 3) {
            a.setUpdated(e, true);
        }
        return true;
    });
    this.attachEvent("onDrop", function (l, h, g, e, c) {
        if (e == c) {
            a.setUpdated(l, true);
        }
    });
    this._onrdlh = function (c) {
        var e = a.getState(c);
        if (e == "inserted") {
            a.set_invalid(c, false);
            a.setUpdated(c, false);
            return true;
        }
        if (e == "true_deleted") {
            a.setUpdated(c, false);
            return true;
        }
        a.setUpdated(c, true, "deleted");
        return false;
    };
    this._onradh = function (c) {
        a.setUpdated(c, true, "inserted");
    };
    a._getRowData = function (h) {
        var g = {};
        var l = this.obj._globalIdStorageFind(h);
        var e = l.parentObject;
        var c = 0;
        for (c = 0; c < e.childsCount; c++) {
            if (e.childNodes[c] == l) {
                break;
            }
        }
        g.tr_id = l.id;
        g.tr_pid = e.id;
        g.tr_order = c;
        g.tr_text = l.span.innerHTML;
        e = (l._userdatalist || "").split(",");
        for (c = 0; c < e.length; c++) {
            g[e[c]] = l.userData["t_" + e[c]];
        }
        return g;
    };
};
// dhtmlXCellObject.prototype.attachTree = function (a) {
//     this.callEvent("_onBeforeContentAttach", ["tree"]);
//     var c = document.createElement("DIV");
//     c.style.width = "100%";
//     c.style.height = "100%";
//     c.style.position = "relative";
//     c.style.overflow = "hidden";
//     this._attachObject(c);
//     this.dataType = "tree";
//     this.dataObj = new dhtmlXTreeObject(c, "100%", "100%", a || 0);
//     this.dataObj.setSkin(this.conf.skin);
//     this.dataObj.allTree.childNodes[0].style.marginTop = "2px";
//     this.dataObj.allTree.childNodes[0].style.marginBottom = "2px";
//     c = null;
//     this.callEvent("_onContentAttach", []);
//     return this.dataObj;
// };
dhtmlXTreeObject.prototype.makeDraggable = function (c, a) {
    if (typeof c != "object") {
        c = document.getElementById(c);
    }
    var dragger = new dhtmlDragAndDropObject();
    var dropper = new dhx_dragSomethingInTree();
    dragger.addDraggableItem(c, dropper);
    c.dragLanding = null;
    c.ondragstart = dropper._preventNsDrag;
    c.onselectstart = new Function("return false;");
    c.parentObject = new Object();
    c.parentObject.img = c;
    c.parentObject.treeNod = dropper;
    dropper._customDrop = a;
};
dhtmlXTreeObject.prototype.makeDragable =
    dhtmlXTreeObject.prototype.makeDraggable;
dhtmlXTreeObject.prototype.makeAllDraggable = function (c) {
    var e = document.getElementsByTagName("div");
    for (var a = 0; a < e.length; a++) {
        if (e[a].getAttribute("dragInDhtmlXTree")) {
            this.makeDragable(e[a], c);
        }
    }
};
dhtmlXTreeObject.prototype.enableItemEditor = function (a) {
    this._eItEd = dhx4.s2b(a);
    if (!this._eItEdFlag) {
        this._edn_click_IE = true;
        this._edn_dblclick = true;
        this._ie_aFunc = this.aFunc;
        this._ie_dblclickFuncHandler = this.dblclickFuncHandler;
        this.setOnDblClickHandler(function (e, c) {
           
            if (this._edn_dblclick) {
               
                this._editItem(e, c);
            }
            return true;
        });
        this.setOnClickHandler(function (e, c) {
           
            this._stopEditItem(e, c);
           
            if (this.ed_hist_clcik == e && this._edn_click_IE) {
               
                this._editItem(e, c);
            }
           
            this.ed_hist_clcik = e;
            return true;
        });
        this._eItEdFlag = true;
    }
};
dhtmlXTreeObject.prototype.setOnEditHandler = function (a) {
    this.attachEvent("onEdit", a);
};
dhtmlXTreeObject.prototype.setEditStartAction = function (a, c) {
    this._edn_click_IE = dhx4.s2b(a);
    this._edn_dblclick = dhx4.s2b(c);
};
dhtmlXTreeObject.prototype._stopEdit = function (c, l) {
    if (this._editCell) {
        this.dADTempOff = this.dADTempOffEd;
        if (this._editCell.id != c) {
            var g = true;
            if (!l) {
                g = this.callEvent("onEdit", [
                    2,
                    this._editCell.id,
                    this,
                    this._editCell.span.childNodes[0].value
                ]);
            }
            else {
                g = false;
                this.callEvent("onEditCancel", [
                    this._editCell.id,
                    this._editCell._oldValue
                ]);
            }
            if (g === true) {
                g = this._editCell.span.childNodes[0].value;
            }
            else {
                if (g === false) {
                    g = this._editCell._oldValue;
                }
            }
            var h = g != this._editCell._oldValue;
            this._editCell.span.innerHTML = g;
            this._editCell.label = this._editCell.span.innerHTML;
            var e = this._editCell.i_sel ? "selectedTreeRow" : "standartTreeRow";
            this._editCell.span.className = e;
            this._editCell.span.parentNode.className = "standartTreeRow";
            this._editCell.span.style.paddingRight = this._editCell.span.style.paddingLeft =
                "5px";
            this._editCell.span.onclick = this._editCell.span.ondblclick = function () { };
            var m = this._editCell.id;
            if (this.childCalc) {
                this._fixChildCountLabel(this._editCell);
            }
            this._editCell = null;
            if (!l) {
                this.callEvent("onEdit", [3, m, this, h]);
            }
            if (this._enblkbrd) {
                this.parentObject.lastChild.focus();
                this.parentObject.lastChild.focus();
            }
        }
    }
};
dhtmlXTreeObject.prototype._stopEditItem = function (c) {
    this._stopEdit(c);
};
dhtmlXTreeObject.prototype.stopEdit = function (a) {
    if (this._editCell) {
        this._stopEdit(this._editCell.id + "_non", a);
    }
};
dhtmlXTreeObject.prototype.editItem = function (a) {
    this._editItem(a, this);
};
dhtmlXTreeObject.prototype._editItem = function (h) {
    if (this._eItEd) {
        this._stopEdit();
        var e = this._globalIdStorageFind(h);
        if (!e) {
            return;
        }
        var g = this.callEvent("onEdit", [0, h, this, e.span.innerHTML]);
        if (g === true) {
            g =
                typeof e.span.innerText != "undefined"
                    ? e.span.innerText
                    : e.span.textContent;
        }
        else {
            if (g === false) {
                return;
            }
        }
        this.dADTempOffEd = this.dADTempOff;
        this.dADTempOff = false;
        this._editCell = e;
        e._oldValue = g;
        e.span.innerHTML = "<input type='text' class='intreeeditRow' />";
        e.span.style.paddingRight = e.span.style.paddingLeft = "0px";
        e.span.onclick = e.span.ondblclick = function (l) {
            (l || event).cancelBubble = true;
        };
        e.span.childNodes[0].value = g;
        e.span.childNodes[0].onselectstart = function (l) {
            (l || event).cancelBubble = true;
            return true;
        };
        e.span.childNodes[0].onmousedown = function (l) {
            (l || event).cancelBubble = true;
            return true;
        };
        e.span.childNodes[0].focus();
        e.span.childNodes[0].focus();
        e.span.onclick = function (l) {
            (l || event).cancelBubble = true;
            return false;
        };
        e.span.className = "";
        e.span.parentNode.className = "";
        var c = this;
        e.span.childNodes[0].onkeydown = function (l) {
            if (!l) {
                l = window.event;
            }
            if (l.keyCode == 13) {
                l.cancelBubble = true;
                c._stopEdit(window.undefined);
            }
            else {
                if (l.keyCode == 27) {
                    c._stopEdit(window.undefined, true);
                }
            }
            (l || event).cancelBubble = true;
        };
        this.callEvent("onEdit", [1, h, this]);
    }
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTreeObject/dxTreeObjectMethods1.js